import { Injectable } from '@angular/core';
import * as PrimeNG from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private messageService: PrimeNG.MessageService) {}

  private create(
    summary: string,
    detail: string,
    duration: number,
    severity: 'info' | 'warn' | 'success' | 'error' = 'info',
  ) {
    this.messageService.add({
      closable: false,
      key: 'bc',
      severity,
      summary,
      detail,
      life: duration,
    });
  }

  info(summary: string, detail: string) {
    this.create(summary, detail, 5000, 'info');
  }

  warn(summary: string, detail: string) {
    this.create(summary, detail, 5000, 'warn');
  }

  success(summary: string, detail: string) {
    this.create(summary, detail, 5000, 'success');
  }

  error(summary: string, detail: string) {
    this.create(summary, detail, 5000, 'error');
  }
}
